import axios from 'axios'

export default {
    namespaced: true,
    state: {
        housingApplicationChecklistStatuses: [],
    },
    mutations: {
        SET_HOUSING_APPLICATION_CHECKLIST_STATUSES(state, payload) {
            state.housingApplicationChecklistStatuses = payload;
        },
    },
    actions: {
        async FetchHousingApplicationChecklistStatuses({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/checklist/statuses/list`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_HOUSING_APPLICATION_CHECKLIST_STATUSES', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchHousingApplicationChecklistStatuses: ${error.message}`));
            });
        },
    },
    getters: {
        HousingApplicationChecklistStatuses(state) { return state.housingApplicationChecklistStatuses; },
    }
}
